<pb-header class="w-100" [fluid]="true" dbHeaderLinkConfig [shouldRemoveLogoLink]="true">
    @if (isAuthenticated$ | async) {
        <db-button (click)="onLogout()" (keydown.enter)="onLogout()">{{'GLOBAL.logout_btn_txt' | translate}}</db-button>
    }
</pb-header>
